import { render, staticRenderFns } from "./typeindex.vue?vue&type=template&id=652b7cf9&"
import script from "./typeindex.vue?vue&type=script&lang=js&"
export * from "./typeindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports